import {Pane} from 'evergreen-ui';
import React from 'react';
import {ClientManagementLayout} from "../layouts/ClientManagementLayout";
import {ParentCaseList} from "./ParentCaseList";
import {initState, parentCaseListReducer} from "./parentCaseListReducer";

export const ParentCasePage = () => {
    const [{pagination, pageSize, sortBy, filter, selected, search}, dispatch] = React.useReducer(parentCaseListReducer, initState())

    return (
        <ClientManagementLayout>
            <Pane minHeight="calc(100vh - 100px - 260px - 36px)" flexGrow={1}>
                <ParentCaseList dispatch={dispatch}
                                pagination={pagination}
                                filterValue={filter}
                                selectedParentCase={selected}
                                searchText={search}
                                sortBy={sortBy}
                                pageSize={pageSize}
                />
            </Pane>
        </ClientManagementLayout>
    );
}
